import * as React from "react";

import FlagListItem from "./FlagListItem";

interface FlagListProps {
  flags: any;
  app_id: number;
  hurdle_name: string;
  onUpdate: Function;
}

class FlagList extends React.Component<FlagListProps, any> {
  constructor(props: FlagListProps) {
    super(props);

    this.state = {
      flags: [],
      writingNewMessage: false,
      showContent: false,
    };
  }

  render() {
    return (
      <ul className="hurdle-checklist">
        {this.props.flags.map((flag, index) => (
          <FlagListItem
            key={index}
            flag={flag}
            app_id={this.props.app_id}
            hurdle_name={this.props.hurdle_name}
            onUpdate={this.props.onUpdate}
          />
        ))}
      </ul>
    );
  }
}

export default FlagList;
